export const PERMISSIONS_CONST = {
  RULES_ENGINE_READ: 'RULES_ENGINE_READ',
  RULES_ENGINE_MANAGE: 'RULES_ENGINE_MANAGE',
  RULES_ENGINE_DEPLOY: 'RULES_ENGINE_DEPLOY'
}